 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-0045ca87":"0af0b953","chunk-062dbe5c":"348e8f9b","chunk-098db03e":"94ec1a3e","chunk-2d0c539a":"e558ae08","chunk-327177d2":"20829d22","chunk-3c16fe56":"a9f9cbe3","chunk-701a376f":"b1d2efa2","chunk-a1979e84":"b2448a75","chunk-e5267ff6":"6f52cd95","chunk-08f9bd35":"4b824b83","chunk-171c8aa6":"2bb75059","chunk-4976f3a2":"1c9debc9","chunk-08df21c1":"d48e53a8","chunk-0c3a0288":"3f7bfdd7","chunk-0d2b4da6":"073fa747","chunk-0d45967c":"7b2dbbb8","chunk-13ec8762":"009298a0","chunk-2d21a58b":"12a53f2b","chunk-2d21a5c4":"918b5149","chunk-adbe5576":"4816c8db","chunk-20324ad6":"948237b5","chunk-2d0ae5a4":"3a5efb1d","chunk-161af9bc":"41e7b062","chunk-2d0b20fa":"8a3355c0","chunk-2d0b213a":"cb1a3fe6","chunk-2d0b3001":"e0929f23","chunk-2d0b6ec9":"0b2869e4","chunk-2d0cf65c":"1623611c","chunk-2d0cf8d2":"55305373","chunk-2d0d76e0":"2029d565","chunk-2d0e4907":"bbfaf037","chunk-2d0e53c0":"4f254db7","chunk-2d0e6732":"c1d8fe1c","chunk-2d0e96e7":"968cde23","chunk-2d2077a1":"6bc96310","chunk-2d225060":"b73100e9","chunk-2d2253aa":"cfe142d7","chunk-2d2295f9":"f2100de7","chunk-2d22dda4":"5a583ca2","chunk-2d238264":"2594c631","chunk-7869b83b":"638dd4e7","chunk-2d0af0e9":"0dc56831","chunk-2d0b1638":"d0841dfc","chunk-2d0b2325":"f544352f","chunk-2d0c09e8":"82fea233","chunk-2d0c26ac":"206d90db","chunk-2d0cca23":"b40ebae8","chunk-2d0cf111":"7c115f88","chunk-2d0d3112":"f8c86f2a","chunk-2d0d437f":"39471aa0","chunk-2d0dd0c7":"57d63868","chunk-2d0e1d55":"4ac5916d","chunk-2d0e5f4f":"59ff8fb2","chunk-2d20f355":"d3233a36","chunk-2d21408a":"7c28d173","chunk-2d214427":"29da4999","chunk-2d21b0ae":"40fe85ac","chunk-2d231214":"7fd3a062","chunk-2d2382b2":"ee4e1a50","chunk-358dde6e":"4f8949ff","chunk-3e93998c":"193297fc","chunk-627a6a48":"1f80d704","chunk-ace7da44":"765d1fcf","chunk-ae8e67fa":"0275d0f0","chunk-b63936b8":"bdc99630","chunk-c6c7e870":"e62a9030","chunk-181cecc3":"60b891c4","chunk-3279c412":"ee412905","chunk-713193ea":"08bf70f8","chunk-f22d54c4":"2d084fd4","chunk-fe297d5c":"8b738294"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-4976f3a2":1,"chunk-08df21c1":1,"chunk-0c3a0288":1,"chunk-0d2b4da6":1,"chunk-0d45967c":1,"chunk-13ec8762":1,"chunk-adbe5576":1,"chunk-358dde6e":1,"chunk-3e93998c":1,"chunk-627a6a48":1,"chunk-ae8e67fa":1,"chunk-c6c7e870":1,"chunk-f22d54c4":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-0045ca87":"31d6cfe0","chunk-062dbe5c":"31d6cfe0","chunk-098db03e":"31d6cfe0","chunk-2d0c539a":"31d6cfe0","chunk-327177d2":"31d6cfe0","chunk-3c16fe56":"31d6cfe0","chunk-701a376f":"31d6cfe0","chunk-a1979e84":"31d6cfe0","chunk-e5267ff6":"31d6cfe0","chunk-08f9bd35":"31d6cfe0","chunk-171c8aa6":"31d6cfe0","chunk-4976f3a2":"2b8b0a1e","chunk-08df21c1":"b15e2f18","chunk-0c3a0288":"10f264c3","chunk-0d2b4da6":"0a4ad17b","chunk-0d45967c":"00b07ab0","chunk-13ec8762":"174a0352","chunk-2d21a58b":"31d6cfe0","chunk-2d21a5c4":"31d6cfe0","chunk-adbe5576":"edcfe217","chunk-20324ad6":"31d6cfe0","chunk-2d0ae5a4":"31d6cfe0","chunk-161af9bc":"31d6cfe0","chunk-2d0b20fa":"31d6cfe0","chunk-2d0b213a":"31d6cfe0","chunk-2d0b3001":"31d6cfe0","chunk-2d0b6ec9":"31d6cfe0","chunk-2d0cf65c":"31d6cfe0","chunk-2d0cf8d2":"31d6cfe0","chunk-2d0d76e0":"31d6cfe0","chunk-2d0e4907":"31d6cfe0","chunk-2d0e53c0":"31d6cfe0","chunk-2d0e6732":"31d6cfe0","chunk-2d0e96e7":"31d6cfe0","chunk-2d2077a1":"31d6cfe0","chunk-2d225060":"31d6cfe0","chunk-2d2253aa":"31d6cfe0","chunk-2d2295f9":"31d6cfe0","chunk-2d22dda4":"31d6cfe0","chunk-2d238264":"31d6cfe0","chunk-7869b83b":"31d6cfe0","chunk-2d0af0e9":"31d6cfe0","chunk-2d0b1638":"31d6cfe0","chunk-2d0b2325":"31d6cfe0","chunk-2d0c09e8":"31d6cfe0","chunk-2d0c26ac":"31d6cfe0","chunk-2d0cca23":"31d6cfe0","chunk-2d0cf111":"31d6cfe0","chunk-2d0d3112":"31d6cfe0","chunk-2d0d437f":"31d6cfe0","chunk-2d0dd0c7":"31d6cfe0","chunk-2d0e1d55":"31d6cfe0","chunk-2d0e5f4f":"31d6cfe0","chunk-2d20f355":"31d6cfe0","chunk-2d21408a":"31d6cfe0","chunk-2d214427":"31d6cfe0","chunk-2d21b0ae":"31d6cfe0","chunk-2d231214":"31d6cfe0","chunk-2d2382b2":"31d6cfe0","chunk-358dde6e":"651bda88","chunk-3e93998c":"641ac447","chunk-627a6a48":"0a4ad17b","chunk-ace7da44":"31d6cfe0","chunk-ae8e67fa":"495245ee","chunk-b63936b8":"31d6cfe0","chunk-c6c7e870":"43b7ccbc","chunk-181cecc3":"31d6cfe0","chunk-3279c412":"31d6cfe0","chunk-713193ea":"31d6cfe0","chunk-f22d54c4":"2b8b0a1e","chunk-fe297d5c":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/vertical/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
